import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M11.394 6.1V18H9.95v-5.559H4.254V18H2.81V6.1h1.445v5.134H9.95V6.1h1.445Zm7.703 4.08c2.193 0 3.366 1.53 3.366 3.451v.731c0 2.023-1.309 3.842-3.978 3.842-2.499 0-4.114-1.887-4.114-4.556v-.85c0-4.488 2.448-6.732 6.783-6.902v1.19c-3.247.153-5.117 1.666-5.32 4.658.73-.969 1.733-1.564 3.263-1.564Zm1.938 4.148v-.646c0-1.36-.629-2.346-2.159-2.346-1.36 0-2.227.578-3.06 1.734v.544c0 2.227 1.071 3.4 2.703 3.4 1.717 0 2.516-1.122 2.516-2.686Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextH6Icon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'textH6'),
) as IconWithRender;

TextH6Icon.displayName = 'TextH6Icon';
TextH6Icon.propTypes = Icon.propTypes;
TextH6Icon.renderIcon = (props) => <TextH6Icon {...props} />;
export default TextH6Icon;
